import React, { useState, useEffect, FC, ReactNode } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { AgentLayoutProps } from "../types/components";
import DashboardLayout from "./layout/DashboardLayout";
import { useAgent } from "../context/AgentContext";
// removed profile completion modal logic

const AgentLayout: FC<AgentLayoutProps> = ({ children }) => {
  const { pendingCompaniesCount } = useAgent();
  const navigate = useNavigate();
  const location = useLocation();
  // removed: showProfileModal state

  useEffect(() => {
    // console.log('DashboardWrapper - User:', user);
    // console.log('DashboardWrapper - User role:', user?.role);
    // console.log('DashboardWrapper - User ID:', user?.userId);
    // removed: modal checks and redirects
  }, [pendingCompaniesCount, location.pathname, navigate]);

  // removed: custom event listener for profile modal

  // removed: modal handlers

  return (
    <DashboardLayout
      agentDetails={{
        pendingCompaniesCount: pendingCompaniesCount,
      }}
    >
      {children}
    </DashboardLayout>
  );
};

export default AgentLayout;
